import { render } from "./TabConfigRatings.vue?vue&type=template&id=eb0e7c4e"
import script from "./TabConfigRatings.vue?vue&type=script&lang=js"
export * from "./TabConfigRatings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__